export const FORM_DATA_VALUES = Object.freeze({
  LONGER_THAN_25_METERS: '>25'
});

export const CUSTOMER_TYPES = {
  PRIVATE: 'Privat',
  COMPANY: 'Firma'
};

export const CUSTOMER_SEX_TYPES = {
  male: 'Herr',
  female: 'Frau',
  divers: 'Divers',
  company: 'Firma'
};

export const PAYMENT_TYPES = {
  VORKASSE: 'Überweisung',
  PAYPAL: 'PayPal',
  KLARNA: 'Sofortüberweisung',
  EINZUG: 'Einzugsermächtigung'
};
